import { getProductIdFromProductCode } from '@noths/polaris-client-utils';
import { R3_ADDTOCART, R3_CART, R3_CATEGORY, R3_COMMON, R3_PURCHASED, R3_SEARCH } from "./rrJsonApi/rrFacade";
export var setCategoryProductCodes = function setCategoryProductCodes(productCodes) {
  productCodes.forEach(function (productCode) {
    var itemId = getProductIdFromProductCode(productCode);
    R3_CATEGORY().addItemId(String(itemId));
  });
};
export var setProductContextCategory = function setProductContextCategory(categoryHintId) {
  R3_COMMON().addCategoryHintId(categoryHintId);
};
export var setProductAddedToBasket = function setProductAddedToBasket(productCode) {
  var itemId = getProductIdFromProductCode(productCode);
  R3_ADDTOCART().addItemIdToCart(String(itemId));
};
export var setSearchResultsProductCodes = function setSearchResultsProductCodes(productCodes) {
  productCodes.forEach(function (productCode) {
    var itemId = getProductIdFromProductCode(productCode);
    R3_SEARCH().addItemId(String(itemId));
  });
};
export var setBasketItem = function setBasketItem(productCode, price, quantity) {
  var itemId = getProductIdFromProductCode(productCode);
  R3_CART().addItemIdPriceQuantity(String(itemId), String(price), String(quantity));
};
export var setOrderNumber = function setOrderNumber(orderNumber) {
  R3_PURCHASED().setOrderNumber(String(orderNumber));
};
export var setPurchasedItem = function setPurchasedItem(productCode, price, quantity, sku) {
  var itemId = getProductIdFromProductCode(productCode);
  R3_PURCHASED().addItemIdPriceQuantity(String(itemId), String(price), String(quantity), sku);
};